/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useState} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { parseHoldsData } from "./selector";
import useToggle from "../../../hooks/use-toggle";
import { HOLDBACK_TYPE } from "../post-inspection-diy-loan-noc-holdback/constant";
import HoldBacks from "./holdbacks";
import { eventScreenTrackingDetails, eventScreenTypes } from "./constant";
import { sendCustomGaEvents } from "../../../tracking";
import { viewDetailNocSessionTime, viewDetailPartyPeshiSessionTime } from "../post-inspection-diy-detailed-holdbacks/tracking";

// eslint-disable-next-line complexity
const PostInspectionDiyHoldbacksV3 = ({
    priceBreakup,
    getPartyPeshifaqsConnect = () => { },
    screenType = eventScreenTypes.OFFER,
    inspectionResponse
}) => {
    const { deductions, priceAfterDeductions } = priceBreakup || {};
    const { appointmentId } = inspectionResponse || {};
    const {
        holds = [],
        totalHolds = 0
    } = deductions || {};
    const [showDetailsModal, setShowDetailModal] = useState("");
    const [showFaqs, setShowFaqs] = useToggle(false);
    const [faqs, setFaqs] = useState([]);
    const [viewTime, setViewTime] = useState(null);

    const sendGaEvents = (details) => {
        sendCustomGaEvents({
            eventLabel: appointmentId,
            ...details
        });
    };

    const getInHandPrice = () => {
        return priceFormatter(priceAfterDeductions - totalHolds);
    };
    const viewDetailHandler = (type) => {
        if ([HOLDBACK_TYPE.LOAN_NOC, HOLDBACK_TYPE.PARTY_PESHI].includes(type)) {
            setShowDetailModal(type);
            setViewTime(Date.now());
            const { partyPeshi, noc } = eventScreenTrackingDetails[screenType];
            if (type === HOLDBACK_TYPE.PARTY_PESHI) sendGaEvents(partyPeshi);
            else sendGaEvents(noc);
        }
    };

    const handleFaqCall = (inView) => {
        if (faqs.length) return;
        if (inView) {
            getPartyPeshifaqsConnect(holds).then(res => {
                setFaqs(res);
            });
        }
    };

    const handleCloseHoldBacks = () => {
        const viewTimerDetails = Date.now() - viewTime;
        setViewTime(null);
        setShowDetailModal("");
        if (showDetailsModal === HOLDBACK_TYPE.PARTY_PESHI) sendGaEvents({...viewDetailPartyPeshiSessionTime, eventLabel: viewTimerDetails});
        else sendGaEvents({...viewDetailNocSessionTime, eventLabel: viewTimerDetails});
    };

    const holdsData = parseHoldsData(holds, getInHandPrice(), viewDetailHandler);

    return (
        <React.Fragment>
            <HoldBacks
                showDetailsModal={showDetailsModal}
                holds={holds}
                showFaqs={showFaqs}
                setShowFaqs={setShowFaqs}
                holdsData={holdsData}
                handleFaqCall={handleFaqCall}
                faqs={faqs}
                showBadgeinLoanPopup={false}
                closeHoldBacks={handleCloseHoldBacks}
            />
        </React.Fragment>
    );
};

PostInspectionDiyHoldbacksV3.propTypes = {
    priceBreakup: PropTypes.object,
    screenType: PropTypes.string,
    getPartyPeshifaqsConnect: PropTypes.func,
    inspectionResponse: PropTypes.object
};

export default PostInspectionDiyHoldbacksV3;
